export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDFc9WMseqEe2eG0CV4QKdWgZf3dlRmvIM',
    authDomain: 'versus-app-dev.firebaseapp.com',
    projectId: 'versus-app-dev',
    storageBucket: 'versus-app-dev.firebasestorage.app',
    messagingSenderId: '188277051447',
    appId: '1:188277051447:web:4ac95f14fd002cf7462fb2',
    measurementId: 'G-27M2KPJM5J',
  },
  dynamicLink: {
    domainUriPrefix: 'dev.versus-studios.com', // Dev domain
    customDeepLinkDomain: 'https://versusapp.page.link',
    iosBundleId: 'com.versusstudios.versusapp.dev',
    androidPackageId: 'com.versusstudios.versus.dev',
    iosAppUrlScheme: 'versus-dev',
  },
};
